// extracted by mini-css-extract-plugin
export const author = "Author-module--author--2kT-Q";
export const author__bio = "Author-module--author__bio--1s0nN";
export const author__photo = "Author-module--author__photo--vfzwM";